import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

const ButtonBlue = styled(Button)({
  backgroundColor: "#e50218",
  borderRadius: "10px",
  fontSize: "14px",
  padding: "0 7px",
  minHeight: "0px !important",
  textTransform: "none !important",
  fontWeight: 600,
  height: "40px",
  color: "#fff",
});

export default ButtonBlue;
